export const connectorStatusEnum = {
  Online: "Online",
  Offline: "Offline",
  Available: "Available",
  Preparing: "Preparing",
  Charging: "Charging",
  SuspendedEV: "SuspendedEV",
  SuspendedEVSE: "SuspendedEVSE",
  Finishing: "Finishing",
  Reserved: "Reserved",
  Unavailable: "Unavailable",
  Faulted: "Faulted",
};
